const AnchoredSection = ({
  id,
  children,
  div,
  ...props
}: { id: string; children: React.ReactChild; div?: boolean } & Partial<
  React.HTMLProps<HTMLDivElement>
>) => {
  const El = div ? 'div' : 'section';
  return (
    <El id={`#${id}`} {...props}>
      {children}
    </El>
  );
};

export default AnchoredSection;
